const TONES = {
  neutral: 'hover:bg-white/[0.1] hover:text-white',
  danger: 'hover:bg-rose-300/15 hover:text-rose-200 hover:border-rose-300/30',
  success: 'hover:bg-emerald-300/15 hover:text-emerald-200 hover:border-emerald-300/30',
};

function ActionButton({ label, onClick, icon: Icon, tone = 'neutral' }) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={label}
      title={label}
      className={`group inline-flex h-11 w-11 items-center justify-center rounded-xl border border-white/10 bg-white/[0.04] text-white/65 transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-violet-300/60 ${TONES[tone]}`}
    >
      <Icon />
    </button>
  );
}

export default ActionButton;